import type Authorization from '$shared/models/Authorization';
import type UserRole from '$shared/models/UserRole';

class AuthData {
  public authorization: Authorization | null = null;

  public get allowViewSensitiveInfo(): boolean {
    return !!this.authorization?.role?.allowViewSensitiveInfo;
  }

  public get userRole(): UserRole | undefined {
    return this.authorization?.role;
  }

  public get isCredAuthType(): boolean {
    return !!this.authorization?.isCredUser;
  }

  public setAuthData(auth: Authorization): void {
    this.authorization = auth;
  }

  public reset(): void {
    this.authorization = null;
  }
}

export const authData = new AuthData();
